/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personalitybigfiveagreeablenessright4Inputs */



/**
* | output |
* | --- |
* | "Hugger" |
*
* @param {Personalitybigfiveagreeablenessright4Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const personalitybigfiveagreeablenessright4 = /** @type {((inputs?: Personalitybigfiveagreeablenessright4Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personalitybigfiveagreeablenessright4Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Hugger")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cariñoso")
	return /** @type {LocalizedString} */ ("Обниматель")
});
export { personalitybigfiveagreeablenessright4 as "personalityBigFiveAgreeablenessRight" }